import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setOfflineModalOpen } from '../../features/offlineModal/offlineModalSlice';
import { RootState } from '../../store';

import { ReactComponent as NoInternetIcon } from '../../assets/images/NoInternetIcon.svg';

interface NoInterNetModal {
    name?: string;
}

export const NoInternetModal: React.FC<NoInterNetModal> = ({ name }) => {
    const dispatch = useDispatch();
    const sideNavIconClickedName = useSelector(
        (state: RootState) => state.offlineModal.sideNavIconClickedName
    );
    const isNoInternetModalOpen = useSelector(
        (state: RootState) => state.offlineModal.isOpen
    );
    if (!isNoInternetModalOpen) return null;
    console.log('No internet modal triggered for ', name);

    return (
        <div
            className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50"
            aria-hidden="true"
        >
            <div className="bg-white rounded-lg shadow-lg w-96 p-6 relative flex space-x-4">
                {/* Icon in the left */}
                <div className="flex flex-row  space-x-4">
                    <NoInternetIcon className="h-8 w-8" />
                </div>
                <div className="text-left flex flex-col">
                    <h2 className="text-lg font-bold mb-1">
                        Internet required!
                    </h2>
                    <p className="text-gray-600 mb-6 flex justify-start ">
                        Please connect to the internet to use{' '}
                        {name ? name : sideNavIconClickedName}.
                    </p>
                    {/* OK Button */}
                    <button
                        onClick={() => dispatch(setOfflineModalOpen(false))}
                        className="px-4 py-2 bg-blue-500 text-white rounded-full hover:bg-blue-600 w-20 ml-[80%] font-sans"
                    >
                        OK
                    </button>
                </div>
            </div>
        </div>
    );
};
